import React from 'react';
import { ObservabilityErrorBoundary } from '@leagueplatform/observability';
import {
  ErrorState,
  ImpersonationTopBanner,
} from '@leagueplatform/web-common-components';

// The support-agent banner for live screens is mounted by AuthSessionContainer
// once the session is signed in, not here: the SDK banner reads the ID token
// claims only once, on mount, and this boundary mounts before the login
// callback has stored the token, so a copy here would stay hidden for the rest
// of the page's life.
//
// The fallback carries its own copy because a caught error replaces everything
// inside the boundary, including the authenticated screens and their banner. It
// mounts only when the error is caught, so it reads the claims as they stand
// then. It renders nothing outside an agent session.
export const RootErrorBoundary = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <ObservabilityErrorBoundary
    fallback={
      <>
        <ImpersonationTopBanner />
        <ErrorState error={null} />
      </>
    }
    errorContext={{
      context: { Context: { location: 'Root App ErrorBoundary' } },
    }}
  >
    {children}
  </ObservabilityErrorBoundary>
);
